module.exports = __webpack_public_path__ + "static/img/3_1_3.2a4f5a24.jpg";